import { Box, Center, Stack, Text } from "@chakra-ui/react";
import * as React from "react";

export interface FeatureItemProps {
  icon: React.ReactElement;
  title: string;
  children: React.ReactNode;

  colorScheme: string;
}

export const FeatureItem = (props: FeatureItemProps) => {
  const { title, children, icon, colorScheme } = props;
  return (
    <Stack direction="row" w="100%" spacing="6">
      <Center
        aria-hidden
        flexShrink={0}
        w="12"
        h="12"
        rounded="md"
        color="white"
        bg={`${colorScheme}.500`}
      >
        {icon}
      </Center>
      <Stack>
        <Text as="h3" fontSize="xl" fontWeight="extrabold">
          {title}
        </Text>
        <Box pr="6" color={"blueGray.600"} lineHeight="tall">
          {children}
        </Box>
      </Stack>
    </Stack>
  );
};
